import { z } from 'zod';

export const zodReprocessingInvoiceEmailEndpointSchema = z.tuple([
  z.literal('invoice'),
  z.literal('process'),
  z.uuid(),
  z.literal('mail'),
  z.uuid(),
]);
